import * as React from 'react';
import { Box, Grid, Paper, Tab } from '@mui/material';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import InformacionDocenteComponent from './components/InformacionDocente';
import SeccionesDocentesComponent from './components/SeccionesDocentes';
import MateriasDocentesComponent from './components/MateriasDocentes';
import CarrerasDocentesComponent from './components/CarrerasDocentes';
import DiasClasesDocentesComponent from './components/DiasClasesDocentes';
import BloquesDocentesComponent from './components/BloquesDocentes';

const PanelDocentesView = () => {
  const [tab, setValue] = React.useState('1');

  const handleTabs = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Grid container spacing={1}>
      <Grid item md={4}>
        <InformacionDocenteComponent />
      </Grid>
      <Grid item md={8}>
        <Paper elevation={4}>
          <TabContext value={tab}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <TabList onChange={handleTabs} aria-label="lab API tabs example">
                <Tab label="Días de clases" value="1" />
                <Tab label="Secciones" value="2" />
                <Tab label="Materias" value="3" />
                <Tab label="Carreras" value="4" />
                <Tab label="Bloques de clases" value="5" />
              </TabList>
            </Box>
            <TabPanel value="1">
              <DiasClasesDocentesComponent />
            </TabPanel>
            <TabPanel value="2">
              <SeccionesDocentesComponent />
            </TabPanel>
            <TabPanel value="3">
              <MateriasDocentesComponent />
            </TabPanel>
            <TabPanel value="4">
              <CarrerasDocentesComponent />
            </TabPanel>
            <TabPanel value="5">
              <BloquesDocentesComponent />
            </TabPanel>
          </TabContext>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default PanelDocentesView;
